import script from "./KPITree.vue?vue&type=script&setup=true&lang=js"
export * from "./KPITree.vue?vue&type=script&setup=true&lang=js"

import "./KPITree.vue?vue&type=style&index=0&id=6a411423&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a411423"]])

export default __exports__